
import React from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { Star } from 'lucide-react';

const HeroSection = () => {
  return (
    <section className="relative bg-gradient-to-r from-brand-charcoal-gray to-black text-white">
      <div className="absolute inset-0 overflow-hidden">
        <img 
          src="https://images.unsplash.com/photo-1632759145351-1d592919f522?w=1920&h=1080&fit=crop&auto=format&q=75" 
          alt="Roof installation by Carolina Trophy Roofs" 
          className="w-full h-full object-cover opacity-30"
          fetchPriority="high"
          loading="eager"
        />
      </div>
      <div className="relative container mx-auto px-4 py-24 md:py-32 flex flex-col items-center text-center">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 drop-shadow-2xl" style={{ 
          fontFamily: '"Cinzel", "Times New Roman", serif',
          fontWeight: '700',
          color: '#FFD700',
          textShadow: '3px 3px 0px #000000, 6px 6px 10px rgba(0,0,0,0.5), 0 0 40px rgba(255, 215, 0, 0.3)',
          letterSpacing: '2px'
        }}>
          Carolina Trophy Roofs
        </h1>
        <p className="text-xl md:text-2xl mb-8 max-w-3xl text-center">
          Voted North Carolina's<br className="sm:hidden" /> 'Best Roofer Near Me'<br />
          in the National Roofing Directory
        </p>
        <div className="flex flex-col sm:flex-row gap-4">
          <Link to="/contact">
            <Button size="lg" className="font-semibold bg-brand-safety-orange hover:bg-brand-safety-orange/90 text-brand-pure-white">
              Free Estimate
            </Button>
          </Link>
          <Link to="/services">
            <Button size="lg" variant="outline" className="bg-white/10 font-semibold border-brand-trophy-gold text-brand-trophy-gold hover:bg-brand-trophy-gold/10">
              Our Services
            </Button>
          </Link>
        </div>
        <div className="flex gap-6 mt-12">
          <div className="flex items-center">
            <Star className="text-brand-trophy-gold mr-2" />
            <span className="font-bold">4.9/5</span>
            <span className="ml-1 text-gray-200">(200+ Reviews)</span>
          </div>
          <div className="hidden sm:block w-px h-8 bg-gray-400"></div>
          <div>
            <span className="font-bold">15+ Years</span>
            <span className="ml-1 text-gray-200">of Experience</span>
          </div>
          <div className="hidden sm:block w-px h-8 bg-gray-400"></div>
          <div>
            <span className="font-bold">Fully Insured</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
